import { HTTP } from '../../http';
import router from '../../router/index';

const state = {
  newClientWizardStep: 1,
  newClientContactDetails: {},
  newClientDrivingPattern: {},
  newClientCreated: false,
  newClientCreateErrors: false,
  currentClient: JSON.parse(localStorage.getItem('exideClient')) || null
};

const mutations = {
  SET_CURRENT_CLIENT(state, data) {
    state.currentClient = data;
    localStorage.setItem('exideClient', JSON.stringify(data));
  },
  SET_NEW_CLIENT_CONTACT_DETAILS(state, data) {
    state.newClientContactDetails = data;
  },
  SET_NEW_CLIENT_DRIVING_PATTERN(state, data) {
    state.newClientDrivingPattern = data;
  },
  SET_NEW_CLIENT_WIZARD_STEP(state, data) {
    state.newClientWizardStep = data;
  },
  SET_NEW_CLIENT_CREATED(state, data) {
    state.newClientCreated = data;
  },
  SET_NEW_CLIENT_CREATE_ERRORS(state, data) {
    state.newClientCreateErrors = data;
  }
};

const getters = {
  getNewClientWizardStep: state => state.newClientWizardStep,
  getNewClientCreated: state => state.newClientCreated,
  getNewClientCreateErrors: state => state.newClientCreateErrors,
  getCurrentClient: state => state.currentClient
};

const actions = {
  createClientAction: ({ commit }) => {
    let clientData = {
      contact_details: state.newClientContactDetails,
      driving_pattern: state.newClientDrivingPattern
    };
    HTTP.post('/api/client/create', clientData)
      .then(response => {
        commit('SET_CURRENT_CLIENT', response.data.client);
        commit('SET_NEW_CLIENT_CREATE_ERRORS', false);
        commit('SET_NEW_CLIENT_CREATED', true);
        router.push({ name: 'BatteryData' });
      })
      .catch(error => {
        if (
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.errors !== undefined
        ) {
          commit('SET_NEW_CLIENT_CREATE_ERRORS', error.response.data.errors);
        } else {
          commit('SET_NEW_CLIENT_CREATE_ERRORS', {});
        }
        commit('SET_NEW_CLIENT_CREATED', {});
      });
  },
  setNewClientWizardStep: ({ commit }, payload) => {
    commit('SET_NEW_CLIENT_WIZARD_STEP', payload);
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
